export const zIndexMap = {
  channelIconBackground: 9,
  channelIcon: 10,
  channelIconLocalRsnIndicator: 20,
  ChannelIconImg: 30,
  ctgBannerLocalRsnTooltipCtnr: 99,
  AccordionSummary: 100,
  TableHead: 500,
  // zipCodeModule is 900 to 902
  pageHeadingTextContainer: 1000
};
